import React from 'react';
import PropTypes from 'prop-types';

const ButtonsTop = props => (
  <section className="module-filter top buttons-top">
    <div className="flex">
      <div className="buttons second-header">
        <div className="tour-aux-light-area top-filters-tour"/>
        <div className="flex filter-box">
          <h2 id={'ffd-type'} className="container-filter-h2">
            <span>{props.language.filter.ffdSleep + ": "}</span>
            {props.language.filter.sleepWristband}
          </h2>
          <ul className="container-filter-ul">
            <li className="container-filter-li no-padding">
              <i className="fas fa-caret-down" />
              <ul data-nonescroll="ok">
                {(props.activeViews.includes('ffdsleep') 
                  && props.permits.includes('ffdsleep')) && (
                  <li>
                    <a
                      role="button"
                      tabIndex={0}
                      data-select={"sleepWristband"}
                      data-parent={`ffd-type`}
                      onClick={props.handleSubmit}
                    >
                      {props.language.filter.sleepWristband}
                    </a>
                  </li>
                )}
                {(props.activeViews.includes('ffdpvt') 
                  && props.permits.includes('ffdpvt')) && (
                  <li>
                    <a
                      role="button"
                      tabIndex={0}
                      data-select={"pvtTest"}
                      data-parent={`ffd-type`}
                      onClick={props.handleSubmitChangeFfdType}
                    >
                      {props.language.filter.pvtTest}
                    </a>
                  </li>
                )}
              </ul>
            </li>
          </ul>
        </div>
        <div className="flex filter-box report-type">
          <h2 id={'report-type'} className="container-filter-h2">
            <span>{props.language.filter.show + ": "}</span>
            {props.language.filter[props.filters.reportType]}
          </h2>
          <ul className="container-filter-ul">
            <li className="container-filter-li no-padding">
              <i className="fas fa-caret-down" />
              <ul data-nonescroll="ok">
                <li>
                  <a
                    role="button"
                    tabIndex={0}
                    data-select={"FFDResult"}
                    data-parent={`report-type`}
                    onClick={props.handleSubmit}
                  >
                    {props.language.filter.FFDResult}
                  </a>
                </li>
                <li>
                  <a
                    role="button"
                    tabIndex={0}
                    data-select={"FFDSync"}
                    data-parent={`report-type`}
                    onClick={props.handleSubmit}
                  >
                    {props.language.filter.FFDSync}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <section className="module-title">
        <h2>{props.language.summary.ffdSleep[props.reportType].title}</h2>
      </section>
    </div>
  </section>
);

export default ButtonsTop;



// WEBPACK FOOTER //
// ./source/client/components/summary_ffd_sleep/buttonsTop.jsx